// plugins/i18n.ts
export default defineNuxtPlugin(() => {
  return {
    provide: {
      i18nGlobal: (key: string) => {
        const nuxtApp = useNuxtApp();
        return nuxtApp.$i18n.t(key);
      },
    },
  };
});
